var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrdinaryCat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.905605,
    y: 0.905605,
    width: 43.469,
    height: 43.469,
    rx: 21.7345,
    stroke: "#FCC436",
    strokeWidth: 1.81121
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8972 10C16.4017 10 16 10.4017 16 10.8972V19.8691C16 23.5298 18.7406 26.5504 22.282 26.9913C22.2809 27.0096 22.2803 27.0279 22.2803 27.0466V33.3269H19.5887C19.0933 33.3269 18.6916 33.7286 18.6916 34.2241C18.6916 34.7195 19.0933 35.1213 19.5887 35.1213H26.7662C27.2617 35.1213 27.6634 34.7195 27.6634 34.2241C27.6634 33.7286 27.2617 33.3269 26.7662 33.3269H24.0747V27.0466C24.0747 27.0279 24.0741 27.0096 24.073 26.9913C27.6145 26.5504 30.355 23.5298 30.355 19.8691V10.8972C30.355 10.4017 29.9532 10 29.4578 10H16.8972ZM17.7944 15.3831V11.7944H28.5606V15.3831H17.7944ZM28.0819 19.5159C27.967 20.5516 27.5272 21.5244 26.8255 22.2947C26.1238 23.0651 25.1962 23.5936 24.1756 23.8044C23.6904 23.9046 23.2158 23.5925 23.1155 23.1072C23.0153 22.6219 23.3274 22.1473 23.8127 22.0471C24.4621 21.9129 25.0524 21.5766 25.499 21.0864C25.9455 20.5962 26.2254 19.9771 26.2985 19.318C26.3531 18.8256 26.7968 18.4706 27.2891 18.5253C27.7817 18.5799 28.1366 19.0234 28.0819 19.5159V19.5159Z",
    fill: "#FCC436"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdinaryCat);
export default __webpack_public_path__ + "static/media/ordinaryCat.febacf0145171abd0bd496fcd748b192.svg";
export { ForwardRef as ReactComponent };